// // src/constants/reportRecommendationMap.ts

// import { FinalRecommendationKey } from "../types/finalDoctorRecommendation";

// export const REPORT_RECOMMENDATION_MAP: Record<
//   string,
//   FinalRecommendationKey
// > = {
//   anthropometry: "growthAndVitals",
//   "mallampati-classification": "growthAndVitals",

//   "eating-behaviours": "dietAndNutrition",

//   "autism-screening": "developmentalMilestones",

//   "sensory-profile": "sensoryProfile",

//   "sleep-health": "sleepHealth",

//   "seizures-epilepsy": "seizuresAndEpilepsy",

//   "blood-examination": "bloodInvestigations",

//   "audiology-screening": "hearing",

//   "vision-screening": "vision",

//   dental: "dentalHealth",

//   "atopic-march-risk": "allergiesAndAtopy",

//   "atopic-dermatitis-risk": "skinAndDermatology",
  

//   "developmental-milestones": "developmentalMilestones",

//   "diet-nutrition": "dietAndNutrition",

//   "general-wellness": "generalWellnessAndLifestyle",

//   "health-history": "parentSummary",
// };




// import { FinalRecommendationKey } from "../types/finalDoctorRecommendation";

// export const REPORT_RECOMMENDATION_MAP: Record<
//   string,
//   FinalRecommendationKey
// > = {
//   "general-wellness": "generalWellnessAndLifestyle",
//   "growth-vitals": "growthAndVitals",
//   "diet-nutrition": "dietAndNutrition",
//   "sleep-health": "sleepHealth",
//   "sensory-profile": "sensoryProfile",
//   "developmental-milestones": "developmentalMilestones",
//   "seizures-epilepsy": "seizuresAndEpilepsy",
//   "allergies-atopy": "allergiesAndAtopy",
//   "skin-dermatology": "skinAndDermatology",
//    "hearing": "hearing",
//   "vision": "vision",
//   "dental-health": "dentalHealth",
//   "blood-investigations": "bloodInvestigations",
// };




import { FinalRecommendationKey } from "../types/finalDoctorRecommendation";

export const REPORT_RECOMMENDATION_MAP: Record<string, FinalRecommendationKey> = {
  "01_general_wellness": "generalWellnessAndLifestyle",
  "02_growth_vitals": "growthAndVitals",
  "03_diet_nutrition": "dietAndNutrition",
  "04_sleep_health": "sleepHealth",
  "05_sensory_profile": "sensoryProfile",
  "06_developmental_milestones": "developmentalMilestones",
  "07_seizures_epilepsy": "seizuresAndEpilepsy",
  "08_allergies_atopy": "allergiesAndAtopy",
  "09_skin_dermatology": "skinAndDermatology",
  "10_hearing": "hearing",
  "11_vision": "vision",
  "12_dental_health": "dentalHealth",
  "13_blood_investigations": "bloodInvestigations"
};